import { ProductOffer, ProductOfferType } from '@percent/cause-dashboard/app/productOffers/data/data.types'
import { ProgramName } from '@percent/cause-dashboard/common/hooks/useCausesDashboardAnalytics/marketplaceAnalytics.types'

const productOffersCatalog = {
  microsoft: {
    type: ProductOfferType.PartnerProduct,
    name: 'Microsoft',
    tracking: ProgramName.Microsoft,
    description:
      'Empower your team, cut costs, and boost security with savings on Microsoft solutions including Azure, Dynamics 365 and Microsoft 365',
    logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Microsoft.png'),
    primaryButton: {
      linkType: 'external',
      link: 'https://www.microsoft.com/en-us/nonprofits/microsoft-365',
      linkText: 'productOffers.apply'
    },
    secondaryButton: undefined,
    searchTags: [
      'productivity',
      'collaboration',
      'cloud',
      'security',
      'IT',
      'software',
      'email',
      'tools',
      'nonprofit',
      'discounts',
      'operations',
      'infrastructure',
      'platform',
      'integration'
    ] as string[]
  },
  microsoft365BusinessPremium: {
    type: ProductOfferType.PartnerProduct,
    name: 'Microsoft 365 Business Premium',
    tracking: ProgramName.Microsoft365BusinessPremium,
    description:
      'Work securely from anywhere with desktop, web, and mobile versions of Microsoft 365 apps, Microsoft 365 Copilot Chat, and enterprise-grade security and access management. Now 75% off for eligible nonprofits.',
    logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Microsoft.png'),
    primaryButton: {
      linkType: 'external',
      link: 'https://www.microsoft.com/en-us/nonprofits/microsoft-365',
      linkText: 'productOffers.getStarted'
    },
    secondaryButton: undefined,
    searchTags: [
      'productivity',
      'collaboration',
      'microsoft',
      'office',
      '365',
      'email',
      'tools',
      'nonprofit',
      'discounts',
      'software'
    ] as string[]
  },
  microsoft365Copilot: {
    type: ProductOfferType.PartnerProduct,
    name: 'Microsoft 365 Copilot',
    tracking: ProgramName.Microsoft365Copilot,
    description:
      'Boost productivity and amplify creativity with Microsoft 365 Copilot, your AI assistant for work. Now available at a 15% discount for eligible nonprofits.',
    logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Microsoft.png'),
    primaryButton: {
      linkType: 'external',
      link: 'https://www.microsoft.com/en-us/nonprofits/empower-your-nonprofit-with-AI',
      linkText: 'productOffers.getStarted'
    },
    secondaryButton: undefined,
    searchTags: [
      'AI',
      'productivity',
      'microsoft',
      'copilot',
      'automation',
      'chat',
      'teams',
      'nonprofit',
      'discounts',
      'software'
    ] as string[]
  },
  microsoftAzureGrant: {
    type: ProductOfferType.PartnerProduct,
    name: 'Microsoft Azure Grant',
    tracking: ProgramName.MicrosoftAzureGrant,
    description:
      'Leverage $2,000 (USD) Azure services credits per year and access the complete portfolio of Azure products and cloud services.',
    logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Microsoft.png'),
    primaryButton: {
      linkType: 'external',
      link: 'https://www.microsoft.com/en-us/nonprofits/azure',
      linkText: 'productOffers.getStarted'
    },
    secondaryButton: undefined,
    searchTags: [
      'cloud',
      'infrastructure',
      'microsoft',
      'azure',
      'grants',
      'credits',
      'nonprofit',
      'hosting',
      'services'
    ] as string[]
  },
  microsoftPowerApps: {
    type: ProductOfferType.PartnerProduct,
    name: 'Microsoft Power Apps',
    tracking: ProgramName.MicrosoftPowerApps,
    description:
      'Build and deploy custom AI apps in a low code environment. Eligible nonprofits get Power Apps free for up to 10 users and discounted pricing of $2.50 (USD) per user per month for additional users.',
    logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Microsoft.png'),
    primaryButton: {
      linkType: 'external',
      link: 'https://www.microsoft.com/en-us/nonprofits/dynamics-365',
      linkText: 'productOffers.getStarted'
    },
    secondaryButton: undefined,
    searchTags: [
      'low code',
      'apps',
      'microsoft',
      'automation',
      'development',
      'AI',
      'nonprofit',
      'discounts',
      'operations'
    ] as string[]
  },
  adobeAcrobatPro: {
    type: ProductOfferType.PartnerProduct,
    name: 'Adobe Acrobat Pro',
    tracking: ProgramName.AdobeAcrobatPro,
    description: 'Save 94% on the essential document solution for nonprofits',
    logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/AdobeAcrobat.png'),
    primaryButton: {
      linkType: 'external',
      link: 'https://adobe.ly/4iQu6Cw',
      linkText: 'productOffers.apply'
    },
    secondaryButton: {
      linkType: 'internal',
      link: '/product-offers/adobe-acrobat-pro',
      linkText: 'productOffers.learnMore'
    },
    searchTags: [
      'documents',
      'PDF',
      'productivity',
      'tools',
      'software',
      'compliance',
      'legal',
      'reporting',
      'administration',
      'nonprofit',
      'discounts'
    ] as string[]
  },
  adobeExpress: {
    type: ProductOfferType.PartnerProduct,
    name: 'Adobe Express',
    tracking: ProgramName.AdobeExpress,
    description:
      'Create and scale your impact for free on web and mobile, by making standout social posts, images, videos, flyers, and more',
    logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/AdobeExpress.png'),
    primaryButton: {
      linkType: 'external',
      link: 'https://adobe.ly/3LtOwFl',
      linkText: 'productOffers.apply'
    },
    secondaryButton: {
      linkType: 'internal',
      link: '/product-offers/adobe-express',
      linkText: 'productOffers.learnMore'
    },
    searchTags: [
      'design',
      'graphics',
      'creative',
      'marketing',
      'social media',
      'content',
      'branding',
      'templates',
      'communications',
      'engagement',
      'video',
      'campaigns',
      'free'
    ] as string[]
  },
  asana: {
    type: ProductOfferType.PartnerProduct,
    name: 'Asana',
    tracking: ProgramName.Asana,
    description: 'Boost team productivity with 50% off Asana’s work management tools and access dedicated support',
    logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Asana.png'),
    primaryButton: {
      linkType: 'external',
      link: 'https://asana.com/industry/nonprofit?utm_source=partner&utm_medium=referral&utm_campaign=goodstack&utm_content=nonprofit-referral',
      linkText: 'productOffers.buyNow'
    },
    secondaryButton: undefined,
    searchTags: [
      'project management',
      'productivity',
      'collaboration',
      'workflow',
      'team',
      'planning',
      'operations',
      'management',
      'tools',
      'software',
      'nonprofit',
      'discounts',
      'tracking'
    ] as string[]
  },
  atlassian: {
    type: ProductOfferType.PartnerProduct,
    name: 'Atlassian',
    tracking: ProgramName.Atlassian,
    description:
      "Collaborate in real-time to meet your organization's goals with 50–100% off Atlassian's AI-powered apps Jira, Confluence, and Loom.",
    logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Atlassian.png'),
    primaryButton: {
      linkType: 'external',
      link: 'https://www.atlassian.com/teams/nonprofits?utm_source=percent&utm_medium=comarketing&utm_campaign=P:multiproduct%7CO:foundation%7CF:discovery%7CW:nonprofit%7CI:percent-marketplace%7C',
      linkText: 'productOffers.apply'
    },
    secondaryButton: undefined,
    searchTags: [
      'project management',
      'productivity',
      'collaboration',
      'software',
      'team',
      'workflow',
      'operations',
      'tools',
      'platform',
      'integration',
      'tracking',
      'planning'
    ] as string[]
  },
  auth0: {
    type: ProductOfferType.PartnerProduct,
    name: 'Auth0',
    tracking: ProgramName.Auth0,
    description: 'Protect critical data with 50% off Auth0’s advanced security tools',
    logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Auth0.png'),
    primaryButton: {
      linkType: 'external',
      link: 'https://validate.goodstack.org/auth0',
      linkText: 'productOffers.apply'
    },
    secondaryButton: undefined,
    searchTags: [
      'security',
      'cybersecurity',
      'authentication',
      'IT',
      'infrastructure',
      'software',
      'compliance',
      'data',
      'protection',
      'platform'
    ] as string[]
  },
  canva: {
    type: ProductOfferType.PartnerProduct,
    name: 'Canva',
    tracking: ProgramName.Canva,
    description: 'Design high-impact marketing materials with Canva, 100% free',
    logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Canva.png'),
    primaryButton: {
      linkType: 'external',
      link: 'https://bit.ly/percent-canva',
      linkText: 'productOffers.apply'
    },
    secondaryButton: undefined,
    searchTags: [
      'design',
      'graphics',
      'creative',
      'marketing',
      'branding',
      'templates',
      'social media',
      'content',
      'visual',
      'communications',
      'engagement',
      'campaigns',
      'free'
    ] as string[]
  },
  claude: {
    type: ProductOfferType.PartnerProduct,
    name: 'Claude',
    tracking: ProgramName.Claude,
    description: 'Elevate your nonprofit’s writing, research, and daily work with access to Claude AI at ~70% off',
    logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Claude.png'),
    primaryButton: {
      linkType: 'external',
      link: 'https://www.claude.com/solutions/nonprofits',
      linkText: 'productOffers.apply'
    },
    secondaryButton: undefined,
    searchTags: [
      'AI',
      'automation',
      'productivity',
      'content',
      'tools',
      'software',
      'technology',
      'innovation',
      'platform'
    ] as string[]
  },
  constantContact: {
    type: ProductOfferType.PartnerProduct,
    name: 'Constant Contact',
    tracking: ProgramName.ConstantContact,
    description:
      'Get 10% off monthly payments, 25% off for a 6-month prepayment, and 35% off for a year prepayment subscription to Constant Contact’s marketing automation tools',
    logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/ConstantContact.png'),
    primaryButton: {
      linkType: 'external',
      link: 'https://go.constantcontact.com/signup.jsp?pn=goodstack',
      linkText: 'productOffers.startFreeTrial'
    },
    secondaryButton: undefined,
    searchTags: [
      'email',
      'marketing',
      'automation',
      'communications',
      'engagement',
      'campaigns',
      'digital marketing',
      'outreach',
      'tools',
      'nonprofit',
      'discounts'
    ] as string[]
  },
  docusign: {
    type: ProductOfferType.PartnerProduct,
    name: 'Docusign',
    tracking: ProgramName.Docusign,
    description:
      'Streamline agreement workflows, scale impact, and boost engagement—with up to 50% off Docusign IAM and 30% off Docusign eSignature',
    logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Docusign.png'),
    primaryButton: {
      linkType: 'external',
      link: `https://ecom.docusign.com/nonprofit/plans/iam?utm_campaign=NAM_US_DXP_AWA_2505_Goodstack&utm_content=marketplace-standard&utm_medium=partner&utm_source=goodstack`,
      linkText: 'productOffers.buyNow'
    },
    secondaryButton: undefined,
    searchTags: [
      'e-signature',
      'documents',
      'workflow',
      'automation',
      'compliance',
      'legal',
      'productivity',
      'operations',
      'administration',
      'tools',
      'software'
    ] as string[]
  },
  easyBoard: {
    type: ProductOfferType.PartnerProduct,
    name: 'Easy Board',
    tracking: ProgramName.EasyBoard,
    description:
      "Access 20% off Easy Board. Transform your board meetings with board and committee management you'll love. Awarded #1 easiest way to engage your board. Special features like magic links for passwordless access, drag and drop agendas, and more!",
    logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/EasyBoard.png'),
    primaryButton: {
      linkType: 'external',
      link: 'https://easyboard.com/goodstack-welcome',
      linkText: 'productOffers.getStarted'
    },
    secondaryButton: undefined,
    searchTags: [
      'board management',
      'governance',
      'meetings',
      'administration',
      'compliance',
      'documentation',
      'collaboration',
      'management',
      'nonprofit',
      'tools'
    ] as string[]
  },
  eventbrite: {
    type: ProductOfferType.PartnerProduct,
    name: 'Eventbrite',
    tracking: ProgramName.Eventbrite,
    description: "Elevate event management with 50% off Eventbrite's premium ticketing and marketing tools",
    logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Eventbrite.png'),
    primaryButton: {
      linkType: 'external',
      link: 'https://www.eventbrite.com/l/npo/',
      linkText: 'productOffers.apply'
    },
    secondaryButton: undefined,
    searchTags: [
      'events',
      'ticketing',
      'marketing',
      'fundraising',
      'community',
      'engagement',
      'registration',
      'management',
      'tools',
      'platform',
      'campaigns'
    ] as string[]
  },
  givebutter: {
    type: ProductOfferType.PartnerProduct,
    name: 'Givebutter',
    tracking: ProgramName.Givebutter,
    description: 'Streamline fundraising and donor management with Givebutter’s free all-in-one fundraising platform',
    logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Givebutter.png'),
    primaryButton: {
      linkType: 'external',
      link: 'https://givebutter.com/?&utm_source=percent&utm_medium=referral&utm_campaign=partner_referrals',
      linkText: 'productOffers.apply'
    },
    secondaryButton: undefined,
    searchTags: [
      'fundraising',
      'donations',
      'donor management',
      'campaigns',
      'events',
      'community',
      'engagement',
      'platform',
      'nonprofit',
      'charity',
      'tools',
      'free'
    ] as string[]
  },
  google: {
    type: ProductOfferType.PartnerProduct,
    name: 'Google',
    tracking: ProgramName.Google,
    description: 'Access Google for Nonprofits, for 70%+ off Workspace tools, and raise awareness through Ad Grants',
    logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Google.png'),
    primaryButton: {
      linkType: 'external',
      link: 'https://bit.ly/percent-google',
      linkText: 'productOffers.apply'
    },
    secondaryButton: undefined,
    searchTags: [
      'productivity',
      'email',
      'collaboration',
      'cloud',
      'advertising',
      'marketing',
      'grants',
      'storage',
      'software',
      'tools',
      'nonprofit',
      'discounts',
      'platform',
      'integration',
      'free'
    ] as string[]
  },
  grantSourcing: {
    type: ProductOfferType.PercentProduct,
    name: 'Goodstack Grants Pro',
    tracking: ProgramName.GrantSourcing,
    description: 'Discover and apply for new grant funding opportunities with help from our AI assistant, Maia',
    logo: require('@percent/cause-dashboard/common/assets/images/goodstack.png'),
    primaryButton: {
      linkType: 'internal',
      link: 'https://causes.goodstack.io/signin?next=%2Fai%3Ftarget%3Dgoodstack-grants?utm_source=causes-portal&utm_medium=link&utm_campaign=product-tile',
      linkText: 'productOffers.getStarted'
    },
    secondaryButton: undefined,
    claimApprovedOnly: true,
    searchTags: [
      'grants',
      'fundraising',
      'funding',
      'applications',
      'AI',
      'nonprofit',
      'finance',
      'donations',
      'research',
      'tools',
      'platform'
    ] as string[]
  },
  gusto: {
    type: ProductOfferType.PartnerProduct,
    name: 'Gusto',
    tracking: ProgramName.Gusto,
    description:
      'Get your first month free when you sign up to Gusto’s online payroll and benefits software built for small businesses',
    logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Gusto.png'),
    primaryButton: {
      linkType: 'external',
      link: 'https://gusto.pxf.io/c/4976018/3214388/15154',
      linkText: 'productOffers.getStarted'
    },
    secondaryButton: undefined,
    searchTags: [
      'payroll',
      'HR',
      'finance',
      'administration',
      'compliance',
      'team',
      'benefits',
      'operations',
      'management',
      'tools',
      'software',
      'nonprofit'
    ] as string[]
  },
  hootsuite: {
    type: ProductOfferType.PartnerProduct,
    name: 'Hootsuite',
    tracking: ProgramName.Hootsuite,
    description:
      'Optimize your social media management, generate awareness and connect with your community with 60% off Hootsuite',
    logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Hootsuite.png'),
    primaryButton: {
      linkType: 'external',
      link: 'https://www.hootsuite.com/pages/landing/non-profit-discount-application-percent?utm_campaign=hootgiving&utm_medium=content_syndication&utm_source=sponsored&utm_partner=goodstack&utm_vertical=non-profit&utm_content=may_general_tile',
      linkText: 'productOffers.buyNow'
    },
    secondaryButton: undefined,
    searchTags: [
      'social media',
      'marketing',
      'engagement',
      'content',
      'scheduling',
      'analytics',
      'communications',
      'digital marketing',
      'campaigns',
      'outreach',
      'community',
      'tools'
    ] as string[]
  },
  linkedInFundraise: {
    type: ProductOfferType.PartnerProduct,
    name: 'LinkedIn Fundraise',
    tracking: ProgramName.LinkedInFundraise,
    description: 'Connect with new donors using 75% off LinkedIn Sales Navigator Core',
    logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Linkedin.png'),
    primaryButton: {
      linkType: 'external',
      link: 'https://validate.goodstack.org/linkedin',
      linkText: 'productOffers.apply'
    },
    secondaryButton: undefined,
    searchTags: [
      'fundraising',
      'networking',
      'outreach',
      'donors',
      'recruitment',
      'engagement',
      'community',
      'social media',
      'campaigns',
      'marketing'
    ] as string[]
  },
  lovable: {
    type: ProductOfferType.PartnerProduct,
    name: 'Lovable',
    tracking: ProgramName.Lovable,
    description: 'Build apps and websites by chatting with AI — access Lovable at a nonprofit discount',
    logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Lovable.png'),
    primaryButton: {
      linkType: 'external',
      link: 'https://validate.goodstack.org/lovable',
      linkText: 'productOffers.apply'
    },
    secondaryButton: undefined,
    searchTags: [
      'AI',
      'app builder',
      'website builder',
      'no code',
      'low code',
      'development',
      'productivity',
      'tools',
      'software',
      'platform',
      'nonprofit',
      'discounts'
    ] as string[]
  },
  // NOTE: LinkedIn is temporarily removing their Recruiter Lite offer
  // linkedInHire: {
  //  type: ProductOfferType.PartnerProduct,
  //  name: 'LinkedIn Hire',
  //  tracking: ProgramName.LinkedInHire,
  //  description: 'Attract top talent with 75% off LinkedIn Recruiter Lite',
  //  logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Linkedin.png'),
  //  primaryButton: {
  //    linkType: 'external',
  //    link: 'https://validate.goodstack.org/linkedin',
  //    linkText: 'productOffers.apply'
  //  },
  //  secondaryButton: undefined
  //},
  mondayCom: {
    type: ProductOfferType.PartnerProduct,
    name: 'monday.com',
    tracking: ProgramName.MondayCom,
    description: 'Manage projects with 10 free users and 70% off additional seats on monday.com',
    logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/MondayCom.png'),
    primaryButton: {
      linkType: 'external',
      link: 'https://monday.com/nonprofits?utm_source=partner_npo&utm_campaign=goodstack&utm_medium=marketplace_011024',
      linkText: 'productOffers.getStarted'
    },
    secondaryButton: undefined,
    searchTags: [
      'project management',
      'productivity',
      'collaboration',
      'workflow',
      'team',
      'operations',
      'planning',
      'tracking',
      'tools',
      'software',
      'nonprofit',
      'discounts',
      'platform',
      'free'
    ] as string[]
  },
  newRelic: {
    type: ProductOfferType.PartnerProduct,
    name: 'New Relic',
    tracking: ProgramName.NewRelic,
    description: 'Monitor performance with 1,000 GB data and three free full-platform users on New Relic',
    logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/NewRelic.png'),
    primaryButton: {
      linkType: 'external',
      link: 'https://newrelic.com/social-impact/signup?utm_source=external_partners&utm_medium=referral&utm_campaign=&utm_content=o4g_signup_page',
      linkText: 'productOffers.apply'
    },
    secondaryButton: undefined,
    searchTags: [
      'monitoring',
      'performance',
      'analytics',
      'data',
      'IT',
      'infrastructure',
      'software',
      'tools',
      'platform',
      'technology',
      'free'
    ] as string[]
  },
  nordlayer: {
    type: ProductOfferType.PartnerProduct,
    name: 'NordLayer',
    tracking: ProgramName.NordLayer,
    description: 'Strengthen network security with 40% off NordLayer’s solutions',
    logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Nordlayer.png'),
    primaryButton: {
      linkType: 'external',
      link: 'https://docs.google.com/forms/d/e/1FAIpQLSeSH8Ye7spg7C6zRUgTgSY6aNDDGJxioKZJPLVdt9wmVSEiyg/viewform?usp=dialog',
      linkText: 'productOffers.getStarted'
    },
    secondaryButton: undefined,
    searchTags: [
      'security',
      'cybersecurity',
      'VPN',
      'networking',
      'IT',
      'infrastructure',
      'protection',
      'compliance',
      'tools',
      'software'
    ] as string[]
  },
  okta: {
    type: ProductOfferType.PartnerProduct,
    name: 'Okta',
    tracking: ProgramName.Okta,
    description: 'Add a secure layer to your systems with 50% off Okta',
    logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Okta.png'),
    primaryButton: {
      linkType: 'external',
      link: 'https://bit.ly/percent-okta',
      linkText: 'productOffers.apply'
    },
    secondaryButton: undefined,
    searchTags: [
      'security',
      'cybersecurity',
      'authentication',
      'IT',
      'infrastructure',
      'compliance',
      'software',
      'platform',
      'identity management'
    ] as string[]
  },
  openAi: {
    type: ProductOfferType.PartnerProduct,
    name: 'OpenAI',
    tracking: ProgramName.OpenAI,
    description: 'Enhance productivity with ChatGPT Team at $8/user/month or save up to 75% on ChatGPT Enterprise',
    logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Openai.png'),
    primaryButton: {
      linkType: 'external',
      link: 'https://validate.goodstack.org/openai',
      linkText: 'productOffers.apply'
    },
    secondaryButton: {
      linkType: 'internal',
      link: '/product-offers/open-ai',
      linkText: 'productOffers.learnMore'
    },
    searchTags: [
      'AI',
      'automation',
      'productivity',
      'content',
      'tools',
      'software',
      'technology',
      'innovation',
      'platform'
    ] as string[]
  },
  quickBooks: {
    type: ProductOfferType.PartnerProduct,
    name: 'QuickBooks',
    tracking: ProgramName.QuickBooks,
    description: 'Get 90% off for 7 months off Quickbooks award winning software',
    logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/QuickBooks.png'),
    primaryButton: {
      linkType: 'external',
      link: 'https://quickbooks.intuit.com/uk/partners/qbba/?cid=par_qbpprsuk_eawocsjdvx5975&ps_partner_key=ZWF3b2NzamR2eDU5NzU&ps_xid=f08olxCYglLPKj&gsxid=f08olxCYglLPKj&gspk=ZWF3b2NzamR2eDU5NzU#plans',
      linkText: 'productOffers.getStarted'
    },
    secondaryButton: undefined,
    allowedCountries: ['UK'] as string[],
    searchTags: [
      'accounting',
      'finance',
      'bookkeeping',
      'reporting',
      'compliance',
      'tax',
      'operations',
      'management',
      'tools',
      'software',
      'nonprofit',
      'discounts'
    ] as string[]
  },
  sage: {
    type: ProductOfferType.PartnerProduct,
    name: 'Sage',
    tracking: ProgramName.Sage,
    description: 'Save 50% on Sage Intacct to streamline and simplify your accounting processes',
    logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Sage.png'),
    primaryButton: {
      linkType: 'external',
      link: 'https://forms.office.com/Pages/ResponsePage.aspx?id=fN0yPvZBLUmho8WOsCz0-PAYGA5Uma5Dk674Gui_6yJUQk8wQktGOVBXRlNIVTg4NUJPSTlHSTcxOC4u',
      linkText: 'productOffers.apply'
    },
    secondaryButton: undefined,
    searchTags: [
      'accounting',
      'finance',
      'reporting',
      'compliance',
      'operations',
      'management',
      'tools',
      'software',
      'nonprofit',
      'discounts',
      'administration'
    ] as string[]
  },
  splunk: {
    type: ProductOfferType.PartnerProduct,
    name: 'Splunk',
    tracking: ProgramName.Splunk,
    description: 'Handle big data with Splunk, free to use for nonprofits',
    logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Splunk.png'),
    primaryButton: {
      linkType: 'external',
      link: 'https://www.splunk.com/en_us/about-us/splunk-pledge/nonprofit-license-application.html',
      linkText: 'productOffers.apply'
    },
    secondaryButton: undefined,
    searchTags: [
      'data',
      'analytics',
      'monitoring',
      'IT',
      'infrastructure',
      'security',
      'reporting',
      'platform',
      'tools',
      'technology',
      'free'
    ] as string[]
  },
  twilio: {
    type: ProductOfferType.PartnerProduct,
    name: 'Twilio',
    tracking: ProgramName.Twilio,
    description: 'Streamline communications with $100 credits and discounts on Twilio’s tools',
    logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Twilio.png'),
    primaryButton: {
      linkType: 'external',
      link: 'https://www.twilio.org/support-and-resources/impact-access-program',
      linkText: 'productOffers.apply'
    },
    secondaryButton: undefined,
    searchTags: [
      'communications',
      'SMS',
      'messaging',
      'automation',
      'engagement',
      'outreach',
      'platform',
      'tools',
      'API',
      'integration'
    ] as string[]
  },
  workvivo: {
    type: ProductOfferType.PartnerProduct,
    name: 'Workvivo',
    tracking: ProgramName.Workvivo,
    description:
      'Connect, inform, and engage your employees - wherever they work. Get 50% off Workvivo and build a culture of belonging and communication across your org',
    logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Workvivo.png'),
    primaryButton: {
      linkType: 'external',
      link: 'https://www.workvivo.com/workvivo-for-good/?utm_source=goodstack_marketplace&utm_medium=tile',
      linkText: 'productOffers.apply'
    },
    secondaryButton: undefined,
    searchTags: [
      'communications',
      'collaboration',
      'team',
      'engagement',
      'culture',
      'HR',
      'platform',
      'tools',
      'social',
      'community'
    ] as string[]
  },
  zoom: {
    type: ProductOfferType.PartnerProduct,
    name: 'Zoom',
    tracking: ProgramName.Zoom,
    description: 'Connect and collaborate seamlessly with your team and community with 50% off Zoom',
    logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Zoom.webp'),
    primaryButton: {
      linkType: 'external',
      link: 'https://www.zoom.com/en/zoom-cares/?utm_source=goodstack&utm_medium=marketplace_zoomcares&utm_campaign=2025_goodstack_marketplace_tile_nonprofits_general&utm_term=social_impact#zoomfornonprofits',
      linkText: 'productOffers.apply'
    },
    secondaryButton: {
      linkType: 'internal',
      link: '/product-offers/zoom',
      linkText: 'productOffers.learnMore'
    },
    searchTags: [
      'video',
      'meetings',
      'collaboration',
      'communications',
      'team',
      'webinars',
      'events',
      'platform',
      'tools',
      'nonprofit',
      'discounts'
    ] as string[]
  },
  keela: {
    type: ProductOfferType.PartnerProduct,
    name: 'Keela',
    tracking: ProgramName.Keela,
    description:
      "Manage donors with 10% off Keela's nonprofit CRM — featuring AI-powered donation forms, automated workflows, email marketing, and robust reporting tools.",
    logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/keela.png'),
    primaryButton: {
      linkType: 'external',
      link: 'https://partnerstack.joinvelora.com/y6kcqh438x32-buuc4c',
      linkText: 'productOffers.getStarted'
    },
    secondaryButton: undefined,
    searchTags: [
      'CRM',
      'donors',
      'fundraising',
      'donation forms',
      'workflows',
      'email marketing',
      'reporting',
      'nonprofit',
      'discounts'
    ] as string[]
  },
  aiForCommunity: {
    type: ProductOfferType.PartnerProduct,
    name: 'AI for Community training',
    tracking: ProgramName.AiForCommunity,
    description:
      'Learn AI tools like ChatGPT, Claude, and Gemini through live, instructor-led training designed for nonprofits. Build confidence via hands-on practice, with a special offer for Goodstack members!',
    logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/ai-for-community.png'),
    primaryButton: {
      linkType: 'external',
      link: 'https://aiforcommunity.org/goodstack-offer?utm_source=goodstack&utm_medium=tile&utm_campaign=goodstack_training_reg_v2&utm_id=Training+Registration',
      linkText: 'productOffers.getStarted'
    },
    secondaryButton: undefined,
    searchTags: [
      'AI',
      'training',
      'ChatGPT',
      'Claude',
      'Gemini',
      'grants',
      'nonprofit',
      'education',
      'outreach'
    ] as string[]
  },
  bugle: {
    type: ProductOfferType.PartnerProduct,
    name: 'Bugle',
    tracking: ProgramName.Bugle,
    description:
      "Streamline your nonprofit's volunteer program and organize all your volunteer events at no cost with Bugle's Community Plan. It's a comprehensive, purpose-built solution for all your volunteer management needs",
    logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Bugle.png'),
    primaryButton: {
      linkType: 'external',
      link: 'https://www.buglevolunteers.com/?utm_source=goodstack&utm_medium=website&utm_campaign=goodstack&utm_id=goodstack',
      linkText: 'productOffers.getStartedFree'
    },
    secondaryButton: undefined,
    searchTags: [
      'volunteers',
      'community',
      'events',
      'management',
      'engagement',
      'coordination',
      'nonprofit',
      'charity',
      'platform',
      'tools',
      'free'
    ] as string[]
  },
  n2f: {
    type: ProductOfferType.PartnerProduct,
    name: 'N2F',
    tracking: ProgramName.N2F,
    description:
      'Get 20% off N2F’s expense management solution through our dedicated nonprofit program. Streamline expense tracking, approvals, and reporting while staying compliant and efficient. Access the offer easily via our nonprofit page and start optimising your financial workflows.',
    logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/N2F.jpg'),
    primaryButton: {
      linkType: 'external',
      link: 'https://www.n2f.com/en/n2f-non-profit-program?utm_source=goodstack&utm_medium=marketplace&utm_campaign=listing',
      linkText: 'productOffers.getStarted'
    },
    secondaryButton: undefined,
    searchTags: [
      'expense management',
      'expenses',
      'nonprofit',
      'receipts',
      'reimbursement',
      'reporting',
      'approvals',
      'tracking',
      'finance',
      'automation'
    ] as string[]
  },
  meta: {}
} as const

type ProductOffersKeys = keyof typeof productOffersCatalog

export const productOffers = productOffersCatalog as Record<ProductOffersKeys, ProductOffer>
